import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../constants/constants";
import { getCurrentToken, getValueFromStorage } from "../helpers/helpers";

export const AnnouncementsApi = createApi({
  reducerPath: "announcements",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-type", "application/json");
      headers.set("authorization", `Bearer ${getCurrentToken()}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAnnouncements: builder.query({
      query: ({ currentPage = 1, resultPerPage = 10000, eventID }) => ({
        url: `api/announcement`,
        method: "GET",
        params: {
          current_page: currentPage,
          result_per_page: resultPerPage,
          event_id: eventID,
        },
      }),
    }),
    putAnnouncement: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `api/announcement/${id}`,
          method: "PUT",
          body: body,
        };
      },
    }),
    addAnnouncement: builder.mutation({
      query: (body) => ({
        url: `api/announcement`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const {
  useGetAnnouncementsQuery,
  useLazyGetAnnouncementsQuery,
  usePutAnnouncementMutation,
  useAddAnnouncementMutation,
} = AnnouncementsApi;
